import { createApiRef } from '@backstage/core-plugin-api';
import type { OnboardingState, PracticeId } from '../types';

export interface OnboardingApi {
  getState(): Promise<OnboardingState>;
  setSelectedPractice(practiceId: PracticeId): Promise<void>;
  markSeenOnboarding(): Promise<void>;
  dismiss(): Promise<void>;
  undismiss(): Promise<void>;
  toggleItem(
    practiceId: PracticeId,
    itemId: string,
    checked: boolean,
  ): Promise<void>;
  resetSetup(): Promise<void>;
}

export const onboardingApiRef = createApiRef<OnboardingApi>({
  id: 'plugin.new-starter-onboarding',
});
